/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Heatingslope1Inputs */



/**
* | output |
* | --- |
* | "Average inertia" |
*
* @param {Br_History_Key_Heatingslope1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_heatingslope1 = /** @type {((inputs?: Br_History_Key_Heatingslope1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Heatingslope1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average inertia")
	return /** @type {LocalizedString} */ ("Inertie moyenne")
});
export { br_history_key_heatingslope1 as "br_history_key_heatingSlope" }